import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import LoadingSpinner from "../../animations/Loadingspinner";
import styled from 'styled-components'
import HeaderComponent from '../headers/headerhome';
import {useNavigate,useLocation} from 'react-router-dom';
import Policies from "../homepage/components/policies";
import useMediaQuery from "../mediahooks/useMedia";
import { maxRowBasedquery } from "../mediahooks//mediamax";
import { Helmet } from "react-helmet"
import {
  useSearchParams
} from "react-router-dom"
//import './signin.css'
// https://javascript.plainenglish.io/creating-a-sign-up-form-in-react-with-typescript-516b1a172913
// TODO Next to collect specific data from database send requests to api with jwttoken in the axios header.
interface IFormInput {
  email: string;
  password: string;
} // Interface form of data
const SigninContainer = styled.div`
max-width: 500px;
min-width: 300px;
max-height: 700px;
width: 30%;
height: 60%;
margin: 100px auto;
background-color: #FFFFFF;
border-radius: 25px;
`
const HeaderTitle = styled(Typography)`
text-align: center;
font-family: 'open sans', sans-serif;
padding: 2rem 0;
margin: 0;
font-size: 2rem;
`
const SigninRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 2rem;
  max-width: 100%;
  :nth-child(3){
    margin: 10px;
    padding-bottom: 1.5rem;
  }
`
const SigninInput = styled(TextField)`
width: 80%;
box-sizing: border-box;
border: none;
font-size: 1.3rem;
padding-left: 1.5rem;
padding-bottom: 1rem;
box-shadow: inset 0px -3px 0px 0px rgba(187,187,187,0.2);
transition: box-shadow 0.2s ease-in;
:focus{
  box-shadow: inset 0px -3px 0px 0px rgba(34,193,195,0.7);
  outline: none;
}
::-webkit-input-placeholder{
  opacity: 1;
  transition: opacity 0.25s ease-out;
}
:hover::-webkit-input-placeholder,
:focus::-webkit-input-placeholder{
  opacity: 0;
}
`
const SigninButton = styled(Button)`
border-radius: 25px;
width: 80%;
height: 40px;
font-size: 1.3rem;
color: white;
font-weight: 700;
background-color: black;
border: 0px;
cursor: pointer;
transition: opacity 0.25s ease-out;
`
const textfieldstyle = {"width":"50%"}
const schema = yup.object().shape({
  email: yup.string().required().email(), 
  password: yup.string().required() //.min(8).max(120),
}); // Create Rigid scheme that the form has to abide by.
function Signin(){
    const [isLoadingLogin, setIsLoadingLogin] = useState<Boolean>(false); // State dealing with loading spinner
    const [noResultsLogin, setNoResultsLogin] = useState<Boolean>(false); // TODO for catch errors
    const [incorrectPassword,setIncorrectPassword] = useState<Boolean>(false); // handles incorrect login
    const [subdoesnotexist,setSetSubdoesnotexist]= useState<Boolean>(false); 
    const [errorsignin,setErrorSignin] = useState<Boolean>(false);
    //const [jwttoken,setJWTToken] = useState<IFormInput>(); // Initialize jwttoken 
    const [loginerror,setLoginError] = useState<Boolean>(false); // handles incorrect login
    let navigate:any = useNavigate(); // use navigate hook to navigate to different pages
    let current_date = new Date().toISOString();
    const maxRowBased = useMediaQuery(maxRowBasedquery);
    let location:any = useLocation();
    const [queryParameters] = useSearchParams()
    const hashedvalue = queryParameters.get("h")
    const externalrevcardusername = queryParameters.get("u")
    let statevalue = location.state;
    const subscription = (statevalue !== null) ? statevalue.subscription : "" 
    const price = (statevalue !== null) ? statevalue.price : ""
    const [extensionerror,setExtensionError] = useState<Boolean>(false);
    const sendTokenToChromeExtension = ({ extensionId, jwt}:any) => {
      //console.log({ extensionId, jwt})
      chrome.runtime.sendMessage(extensionId, { jwt }, response => {
        //console.log(response);
        if (!response.success) {
          console.log('error sending message', response);
          //setExtensionError(true)
          //return response;
        }
        //console.log('Sucesss ::: ', response.message)
      });
    }
    const checkSubscriptionEndDate = async (token:string,json:any,subscription:any) => {
      const config = {headers: {Authorization: `Bearer ${token}`,}}
      const responseget:any = await axios.get(`https://revisionbankbackendsql-aoz2m6et2a-uc.a.run.app/getsubscription`,config); // Send login post request.
      //console.log(responseget.data);
      let end_date = responseget.data.end_date_subscription
      const responsegetft:any = await axios.get(`https://revisionbankbackendsql-aoz2m6et2a-uc.a.run.app/getfreetrial`,config);  
      const responsegetstudent:any = await axios.get(`https://revisionbankbackendsql-aoz2m6et2a-uc.a.run.app/checkstudentsubscriptions`,config);
      //console.log(su)

      if (responsegetft.data.freetrial !== undefined || responseget.data.end_date_subscription !== undefined || responsegetstudent.data.student_subscription !== "student_educational" ){       
        // Storing from external revision card
        if (hashedvalue !== null && externalrevcardusername !== null){
          setIsLoadingLogin(true)
          const responsecard:any = await axios.get(`https://revisionbankcardlink-aoz2m6et2a-uc.a.run.app/getcard?h=${hashedvalue}&u=${externalrevcardusername}`);
          const revisioncard = responsecard.data
          var notecardjson = {"revisioncardscheduler":{"sendtoemail":json.email,"revisionscheduleinterval":60,"revisioncards":[revisioncard]}}
          //console.log(json)
          
          const responsestore:any = await axios.post("https://revisionbankbackendsql-aoz2m6et2a-uc.a.run.app/storerevisioncards",notecardjson,config)
          
          navigate("/revisioncards",{state:{"token":token}})
        }
        else if (end_date < current_date) {
          console.log("Subscription has expired")
          navigate("/pricing",{state:{"token":token,"pre_subscription_expiration":"expired","email":json.email}})
          const config = {headers: {Authorization: `Bearer ${token}`,}}
          const responsedel:any = await axios.delete(`https://revisionbankbackendsql-aoz2m6et2a-uc.a.run.app/deletesubscription`,config);
          // TODO Test this by looking on whether it works if the dates are in the future.
        }
        else if (end_date === current_date) {
          console.log("Subscription will expire today")
          navigate("/revisioncards",{state:{"token":token,"email":json.email}})
        }
        else if (end_date > current_date) {
          console.log("Subscription will expire on " + end_date)
          navigate("/revisioncards",{state:{"token":token,"email":json.email}})
        }
        else if (responseget.data.subscription === undefined && subscription === "basic"){
          navigate("/revisioncards",{state:{"token":token,"email":json.email}})
        }
        else if (responseget.data.end_date_subscription === undefined && (subscription === "standard"|| subscription === "premium" || subscription === "educational" )) {
        //console.log(token)
          navigate("/pricing",{state:{"token":token,"pre_subscription_expiration":"expired","email":json.email}})
          //console.log("Subscription doesn't exist")
          setSetSubdoesnotexist(true)
          //

        }
        else if (subscription === "freetrial") {
          navigate("/completefreetrial", { state: { token: token, subscription: subscription,email:json.email} });
        }
        else if (responseget.data.end_date_subscription === undefined ) {
            navigate("/revisioncards",{state:{"token":token,"email":json.email}})
            setSetSubdoesnotexist(true)
            //
  
          }
    }
    else if (responsegetft.data.freetrial === undefined && responseget.data.end_date_subscription === undefined) {
      
      navigate("/completefreetrial", { state: { token: token, subscription: "freetrial",email:json.email} });
    }
    }
  
    const { register: registerLogin,handleSubmit: handleSubmitLogin ,formState: { errors: loginerrors },} = useForm<IFormInput>({
        resolver: yupResolver(schema),
      }); // stores data from form into register data and handler,using "registerLogin" and "handleSubmitLogin" as aliases
    const onSubmitLogin = async (data: IFormInput) => { 
        setIncorrectPassword(false) // Resets Incorrect password state
        setNoResultsLogin(false); // Resets error handling state
        setIsLoadingLogin(true); // Starts loading spinner
        try{
        var json = JSON.parse(JSON.stringify(data)); // Converts data to json
        json.email = json.email.toLowerCase();
        const response:any = await axios.post(`https://revisionbankbackendsql-aoz2m6et2a-uc.a.run.app/loginapi`, json); // Send login post request.
        if ("error" in response.data){
          alert(response.data.error)
        }
        if (response.data !== undefined){
          if ("access_token" in response.data){
            if (maxRowBased === true){
              //,,,,"nccilomakbaelofffbahenkpchbfpakj"
              //sendTokenToChromeExtension({ extensionId:"iobiemloodjhefphlbljaoenadbhnamk", jwt: response.data.access_token}) // 'iobiemloodjhefphlbljaoenadbhnamk'
            }
            checkSubscriptionEndDate(response.data.access_token,json,subscription)
             // Navigate to home page


          }
        }
        if ("message" in response.data){
          setIncorrectPassword(true)
        }
        setIsLoadingLogin(false); 
      
  //setJWTToken(response.data); // response is a jwttoken which is basically a footprint for the user to access certain data
       // Stops spinner
        }
        catch(error){
          console.log(error)
          setErrorSignin(true) // Error handling
          setIsLoadingLogin(false); 
        }

        
    
      };
    

    return(
      <div>
          <Helmet>
          <title>RevisonBank Signin</title>
          <meta
          name="description"
          content="RevisionBank signin for practice questsion, exam questions and revision cards for AS and A level students."
          />
          <meta
              name="keywords"
              content="Revision,revisionbank signin,revision bank signin,solution bank signin,revision bank,revisionbank,Revision Bank,RevisionBank,solutionbank,solution bank year 1,solution bank pure maths year 1,revision village,solution bank year 1 stats,solution bank year 2,solution bank,Solutionbank,Solution Bank,A Level revision, Practice Papers, Revision Bank, Revision Bank Scraper, Revision Bank Scraper for A Level, Revision Bank Scraper for O Level, Revision Bank Scraper for GCSE, Revision Bank Scraper for IB, Revision Bank Scraper for A Level Practice Papers, Revision Bank Scraper for O Level Practice Papers, Revision Bank Scraper for GCSE Practice Papers, Revision Bank Scraper for IB Practice Papers, Revision Bank Scraper for A Level Revision Cards, Revision Bank Scraper for O Level Revision Cards, Revision Bank Scraper for GCSE Revision Cards, Revision Bank Scraper for IB Revision Cards, Revision Bank Scraper for A Level Revision Practice Papers, Revision Bank Scraper for O Level Revision Practice Papers, Revision Bank Scraper for GCSE Revision Practice Papers, Revision Bank Scraper for IB Revision Practice Papers, Revision Bank Scraper for A Level Revision Practice Cards, Revision Bank Scraper for O Level Revision Practice Cards, Revision Bank Scraper for GCSE Revision Practice Cards, Revision Bank Scraper for IB Revision Practice Cards, Revision Bank Scraper for A Level Revision Practice Cards, Revision Bank Scraper for O Level Revision Practice Cards, Revision Bank Scraper for GCSE Revision Practice Cards, Revision Bank Scraper for IB Revision Practice Cards, Revision Bank Scraper for A Level Revision Practice Cards, Revision Bank Scraper for O Level Revision Practice Cards, Revision Bank Scraper for GCSE Revision Practice Cards, Revision Bank Scraper for IB Revision Practice Cards, Revision Bank Scraper for A Level Revision Practice Cards, Revision Bank Scraper for O Level Revision Practice Cards, Revision Bank Scraper for GCSE Revision Practice Cards, Revision Bank Scraper for IB Revision Practice Cards, Revision Bank Scraper for A Level Revision Practice Cards, Revision Bank Scraper for O Level Revision Practice Cards, Revision Bank Scraper for GCSE Revision Practice Cards, Revision Bank Scraper for IB Revision Practice Cards, Revision Bank Scraper for A Level Revision Practice Cards, Revision Bank Scraper for O Level Revision Practice Cards, Revision Bank Scraper for GCSE Revision Practice Cards, Revision Bank Scraper for IB Revision Practice Cards, Revision Bank Scraper for A Level Revision Practice Cards, Revision Bank Scraper for O Level Revision Practice Cards, Revision Bank Scraper for GCSE Revision Practice Cards, Revision Bank Scraper for IB Revision Practice Cards, Revision Bank Scraper for A Level Revision Practice Cards, Revision Bank Scraper for O Level Revision Practice Cards, Revision Bank Scraper for GCSE Revision Practice Cards, Revision Bank Scraper for IB"
          />
          </Helmet>
      <HeaderComponent hashedvalue={hashedvalue} externalrevcardusername={externalrevcardusername}/>
      <SigninContainer>
        <HeaderTitle variant="h2">
          Sign in
        </HeaderTitle>
        
      

        
        <form onSubmit={handleSubmitLogin(onSubmitLogin)} noValidate>
        <SigninRow>
          <SigninInput style={textfieldstyle}
            {...registerLogin("email")}
            variant="outlined"
            margin="normal"
            label="Email"
            helperText={loginerrors.email?.message}
            error={!!loginerrors.email?.message}
            fullWidth
            required
          />
         </SigninRow>
         <SigninRow>
          <SigninInput style={textfieldstyle}
            {...registerLogin("password")}
            variant="outlined"
            margin="normal"
            label="Password"
            helperText={loginerrors.password?.message}
            error={!!loginerrors.password?.message}
            type="password"
            fullWidth
            required
          />
          </SigninRow>
          <SigninRow>
          {isLoadingLogin ? <LoadingSpinner /> : null}
          {noResultsLogin ? <p>No Results Found</p> : null}
          {errorsignin && <p>Check your network connection.</p>}
          {incorrectPassword && <p>The username or password is incorrect.</p>}
          {subdoesnotexist && <p>Subscription does not exist.</p>}
          <SigninButton 
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
          >
           <p style={{fontSize:"13px",marginTop:"5px"}}>Sign in</p>
          </SigninButton >
          </SigninRow>
        

        </form>
        <div style={{position:"relative",bottom:"10px",left:maxRowBased ? "30%" : "16%"}}>
        <a style={{color:"#264BE4"}}href="/forgotpassword">Forgot your password?</a>
        </div>
        </SigninContainer>
        <Policies></Policies>
      </div>
    )
}

export default Signin;